import styled from "styled-components";
import { Layout } from "antd";
export const NavContainer = styled(Layout.Header)`
  padding: 0;
  background: #fff;
`;
